const $ = require('jquery');

const classDropdownVisible = 'filter--dropdown-visible',
classTextInput = 'filter--text';

$('.filters .filter__current').on('click', function(e) {
    e.stopPropagation();

    let $filter = $(this).closest('.filter');

    if (!$filter.hasClass(classTextInput)) {
        if ($filter.hasClass(classDropdownVisible)) {
            $filter.removeClass(classDropdownVisible);
        } else {
            $filter.siblings().removeClass(classDropdownVisible); // close other open filter dropdowns
            $filter.addClass(classDropdownVisible);
        }
    } else {
        let $input = $filter.find('input');
           inputLen = $input.val().length; 

        // always move focus to end of input field
        $input[0].setSelectionRange(inputLen, inputLen);
        $input.focus(); 
    }

});

// close open filter dropdowns when clicking outside
$(document).on('click', function (e) {
    // close modals when clicking outside window
    if (!$(e.target).closest('.filter').length > 0) {
        $('.filters .filter').removeClass(classDropdownVisible);
    }
});

// update main filter input with current filters
function updateCurrentFilters($filter) {
    if (typeof $filter === 'undefined') return false;

    let $inputCurrentFilter = $filter.find('input.filter__input'),
        selectedOptions = $filter.find('.filter__options input:checked'),
        currentValue = '';

    if (selectedOptions.length > 0) {
        if (selectedOptions.length > 1) {
            selectedOptions.each(function(index) {
                let isLastElement = index === selectedOptions.length -1;

                currentValue += $(this).data('label');
                if (!isLastElement) {
                    currentValue += ', ';
                }
            });
        } else {
            currentValue = selectedOptions.data('label');
        }
    }

    if ($filter.hasClass(classTextInput)) {
        currentValue = $inputCurrentFilter.val(); 
    }

    $inputCurrentFilter.val(currentValue);
}

$('.filters .filter').each(function() {
    let $filter = $(this),
        $form = $(this).closest('form'),
        enter = 13; 

    $('.filter__options input', this).on('change', function() {
        updateCurrentFilters($filter);

        $('body').addClass('loader-visible');
        $form.submit();
    });

    // if enter is pressed within text input filter
    if ($filter.hasClass(classTextInput)) {
        $(this, 'input').on("keypress", function(e){
            if(e.which == enter){
                updateCurrentFilters($filter);

                $('body').addClass('loader-visible');
                $form.submit(); 
            }
        });
    }

    updateCurrentFilters($filter);
});